module.exports = __webpack_public_path__ + "img/serve1.2bb3e192.png";